// Local token snapshot from the AgentStudio superadmin design system
// (tokens/colors.css). Independent of the app's live MUI theme on purpose —
// this page ports a specific visual language, not whatever theme.js has.
const tokens = {
  primary: "#0A474C",
  primaryLight: "#EBF5F3",
  secondary: "#FEC000",
  green: "#00C16E",
  link: "#1C8F73",

  success: "#4CAF50",
  error: "#F44336",
  warning: "#FFC260",
  info: "#9013FE",
  pending: "#E65100",
  resolved: "#388E3C",

  textPrimary: "#4A4A4A",
  textSecondary: "#6E6E6E",
  textHint: "#B9B9B9",
  textOnDark: "#FFFFFF",
  textDisabled: "#ADADAA",

  bg: "#F6F7FF",
  bgLight: "#F3F5FF",
  surface: "#FFFFFF",
  inputFill: "#F0F0F0",
  disabledFill: "#EBEBEE",
  track: "#EEF0F4",

  border: "#E4E4EE",
  borderStrong: "#D5D5DF",
  divider: "#ECECF4",

  radiusDefault: 6,
  radiusPill: 999,
  radiusInput: 8,

  fontBody: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontHeading: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
};

export default tokens;
